import { render, staticRenderFns } from "./itemUpdate.vue?vue&type=template&id=b86c67e4&scoped=true"
import script from "./itemUpdate.vue?vue&type=script&lang=js"
export * from "./itemUpdate.vue?vue&type=script&lang=js"
import style0 from "./itemUpdate.vue?vue&type=style&index=0&id=b86c67e4&prod&scoped=true&lang=css"
import style1 from "./itemUpdate.vue?vue&type=style&index=1&id=b86c67e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c67e4",
  null
  
)

export default component.exports